'use strict';

import { BaseController } from '../../base/controller';

export class AddressFormularController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  $onInit() {
    this.messages = {
      'required' : 'app.addressFormular.required'
    };
  }

  submitForm() {
    if (this.form.$valid) {
      this.onSubmit();
      this.form.$setPristine();
      this.form.$setUntouched();
    }
  }
}
